<template>
  <div id="buyshouhu">
    <!--选择开通日期-->
    <div class="d1 whiteB o05rem">
      <p>请选择开通守护时间</p>
      <ul class="overHidden flex-box">
        <li
          class="relativeItem radius05rem"
          :class="{ clickedli: active == index }"
          v-for="(n, index) in data"
          :key="index"
          @click="active = index"
        >
          <div class="absoluteItem centerImg">
            <p class="p1">{{ n.name }}</p>
            <p class="p2">{{ n.timeName }}</p>
          </div>
          <img
            class="absoluteItem"
            src="../../assets/shouhu.png"
            v-show="active == index"
          />
        </li>
      </ul>
    </div>
    <!--特权说明-->
    <div class="d2 whiteB o05rem">
      <p>守护特权</p>
      <ul class="overHidden flex-box">
        <li>
          <img src="../../assets/shouhu (5).jpg" />
          <p class="p1">守护坐席</p>
          <p class="p2">特殊坐席力压众人</p>
        </li>
        <li>
          <img src="../../assets/shouhu (6).jpg" />
          <p class="p1">守护勋章</p>
          <p class="p2">守护专属身份勋章</p>
        </li>
        <!-- <li>
          <img src="../../assets/shouhu (1).jpg">
          <p class="p1">守护座驾</p>
          <p class="p2">专属身份座驾</p>
        </li> -->

        <li>
          <img src="../../assets/shouhu (2).jpg" />
          <p class="p1">欢迎进场</p>
          <p class="p2">进场炫酷特效</p>
        </li>
        <li>
          <img src="../../assets/shouhu (3).jpg" />
          <p class="p1">守护话框</p>
          <p class="p2">与众不同炫酷话框</p>
        </li>
        <!-- <li>
          <img src="../../assets/shouhu (4).jpg">
          <p class="p1">加速升级</p>
          <p class="p2">消费额外获得经验</p>
        </li> -->
      </ul>
    </div>
    <!--支付-->
    <div class="d3 whiteB" v-show="show">
      <p class="p1">
        <span class="s1">开通守护：</span>
        <img src="../../assets/diamond.png" />
        <span class="s2">{{ buyInfo.price }}</span>
      </p>
      <p class="p2">
        <span class="s1">当前守护，</span>
        <span class="s2" v-if="allInfo.type == 3"
          >有效期至{{ allInfo.nowaday }}</span
        >
        <span class="s2" v-if="allInfo.type == 1">未开通</span>
        <span class="s2" v-if="allInfo.type == 2">已过期</span>
      </p>
      <p class="p2">
        <span class="s1">即将开通守护，</span>
        <span class="s2">有效期至{{ buyInfo.validity }}</span>
      </p>
      <button class="absoluteItem centerY radius3" @touchstart="appPay">
        去开通
      </button>
    </div>
  </div>
</template>













<script>
export default {
  name: "buyshouhu",
  components: {},
  data() {
    return {
      click: true,
      show: false,
      active: 0,
      data: [],
      buyInfo: [],
      usernumber: "",
      allInfo: [], //拿到的所有信息
    };
  },
  computed: {},
  methods: {
    /**获取时间和金额 */
    getShouhuData() {
      let _this = this;
      let data = {};
      if (this.$tool.isStr(this.$route.query.uid)) {
        data.userid = this.$route.query.uid;
      } else {
        this.$tool.tip("主播不明确");
        return;
      }
      this.$jsonp(this.$apis("shouhudata"), data, (res) => {
        if (res.data.data.status != 200) {
          alert(res.data.data.msg);
        }
        _this.data = res.data.data.data;
        _this.allInfo = res.data.data;
        _this.usernumber = res.data.data.usernumber;
        setTimeout(() => {
          _this.buyInfo = _this.data[_this.active];
          _this.show = true;
        }, 500);
      });
    },
    /**下单 */
    cOrder() {
      let _this = this;
      let data = {
        type: "guard",
        extra:
          this.usernumber +
          "_" +
          this.$route.query.userid +
          "_" +
          this.data[this.active].id,
      };
      this.$pay.crOrder(data, (res) => {
        if (res.data.data.status == 200) {
          //进行支付
        } else {
          //提示
          _this.$tool.tip(res.data.data.msg);
        }
      });
    },
    /**让app用钻石支付 */
    appPay() {
      if (this.click) {
        this.click = false;
      } else {
        return;
      }
      this.$tool.showLoading();
      let data = {
        extra: this.$route.query.uid + "_" + this.data[this.active].id,
      };
      let _this = this;
      this.$jsonp(this.$apis("buyshouhu", "app"), data, (res) => {
        _this.$tool.hiddenLoading();

        setTimeout(() => {
          if (res.data.data.status == 200) {
            _this.$tool.tip("开通成功");
            _this.getShouhuData();

            /**在app内部让app返回主播页面，现在只是IOS需要 */
            let st = setTimeout(() => {
              clearTimeout(st);
              _this.$appAc.shouhuNotice();
            }, 1000);
          } else if (res.data.data.status == 497) {
            _this.$tool.hiddenLoading();
            _this.$tool.download("download", res.data.data.msg);
          } else {
            _this.$tool.tip(res.data.data.msg);
          }
          _this.click = true;
        }, 1000);
      });
    },
  },
  mounted: function () {
    this.$emit("showOhidden", false, 3);
    this.$tool.setTitle("开通守护");
    this.getShouhuData();
  },
  watch: {
    active() {
      this.buyInfo = this.data[this.active];
    },
  },
};
</script>











<style scoped>
#buyshouhu {
  padding-bottom: 6rem;
}
/*选择天数*/
.d1 > p {
  color: #999;
  font-size: 15px;
  padding: 0.5rem 0;
}
.d1 ul,
.d2 ul {
  justify-content: space-between;
  flex-wrap: wrap;
}
.d1 li {
  width: 49%;
  height: 4.5rem;
  background: #fafafa;
  border: 2px solid #fafafa;
  margin-bottom: 0.5rem;
  text-align: center;
}
.d1 div .p1 {
  font-size: 16px;
}
.d1 div .p2 {
  font-size: 13px;
  color: #999;
  margin-top: 0.1rem;
}
.d1 .clickedli {
  border: 2px solid #fd79a8;
  background: #fff;
}
.d1 img {
  bottom: 5px;
  right: 5px;
  width: 1rem;
}
.d1 .clickedli .p1 {
  color: #fd79a8;
}

/*特权说明*/
.d2 > p {
  padding: 0.5rem 0;
  margin-bottom: 0.5rem;
}
.d2 li {
  width: 50%;
  text-align: center;
  margin-bottom: 1rem;
}
.d2 img {
  width: 30%;
}
.d2 .p1 {
  font-size: 14px;
  margin: 0.1rem 0;
}
.d2 .p2 {
  font-size: 12px;
  color: #999;
}

/*支付*/
.d3 {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 0.5rem;
}
.d3 .p1 {
  font-size: 14px;
}
.d3 .p1 * {
  vertical-align: middle;
}
.d3 .p1 img {
  width: 1rem;
}
.d3 .p1 .s2 {
  font-weight: 600;
}
.d3 .p2 {
  font-size: 12px;
  color: #999;
}
.d3 .p2 .s2 {
  color: #fd79a8;
}
.d3 button {
  right: 0.5rem;
  padding: 0.4rem 0.7rem;
  color: #fff;
  background: -webkit-linear-gradient(left, #ff86ca, #fc3fa8);
  background: linear-gradient(to right, #ff86ca, #fc3fa8);
}
</style>
